import type { BadgeColor } from '@enamelai/design-system'
import { WorkStatus } from '@constants/Providers'

import type { TeamCatalog } from '@context/TeamCatalog.context'

export const teamForRole = (
  workRole: string | undefined,
  catalog: TeamCatalog,
): string =>
  workRole
    ? Object.prototype.hasOwnProperty.call(catalog.roleToTeam, workRole)
      ? catalog.roleToTeam[workRole]
      : catalog.defaultTeam
    : ''

export const TEAM_BADGE_COLOR: BadgeColor = 'vivid-green'

export const WORK_STATUS_BADGE_COLORS: Record<string, BadgeColor> = {
  [WorkStatus.ACTIVE]: 'vivid-green',
  [WorkStatus.HALF_DAY]: 'orange',
  [WorkStatus.ON_LEAVE]: 'yellow',
  [WorkStatus.INACTIVE]: 'gray',
}
